"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const Constants_1 = require("./../../commons/Constants");
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const vasat_1 = require("vasat");
const map_service_1 = require("../../commons/map.service");
const app_service_1 = require("../../commons/app.service");
const acl_service_1 = require("../../commons/acl/acl.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const user_add_dialog_1 = require("./user-add.dialog");
const forms_1 = require("@angular/forms");
const share_project_dialog_component_1 = require("./share-project/share-project-dialog.component");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const core_2 = require("@ngx-translate/core");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
class UsersComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, mapService, service, permissions, router, snackBar, dialog, uiManager, activeRoute, applicationEvents, t) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.mapService = mapService;
        this.service = service;
        this.permissions = permissions;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.uiManager = uiManager;
        this.activeRoute = activeRoute;
        this.t = t;
        this.groups = [];
        this.userList = new rxjs_1.BehaviorSubject([]);
        this.sharedProjectControl = new forms_1.FormControl();
        // roles: Set<any> = null ;
        // roleSelected: string = null;
        this.allowed = null;
        this.userRoles = null;
        this.test = null;
        this.resources = null;
        this.viewRole = null;
        this.viewRoleResources = null;
        this.viewRoleAllowed = null;
        // we want sometimes to not sort the order of iterated objects
        this.keyOrderNone = (a, b) => {
            return 0;
        };
    }
    init() {
        this.addSubscription('userReady', this.fourD.onSocketCommand('user_joined').subscribe(s => {
            console.log('hb!!!!');
            this.onReady();
        }));
        // fetch all features
        // result should go in this.viewRoleResources
        // fetch all roles
        this.fourD.V.searchByObject(vasat_1.Role).equals("desc", "4D Mapper|4D User").queryObservable().subscribe(s => {
            this.roles = s.items;
        });
    }
    onReady() {
        // fetch all roles
        // this.roles = this.permissions.getRoles();
        // if a user has no role, give them one of these defaults
        let defaults = this.permissions.getDefaults();
        Constants_1.Constants.showHangOn();
        // get all actual users and user groups
        this.refreshUserGroups().pipe(operators_1.flatMap(_ => this.refreshInvited())).subscribe(ret => {
            /*
              // shortcut, saving the list of user roles (what given, or set by default)
              let a = this.fourD.activeTeam;
        
              // do we support multiple roles per user?
              const supportMulti = false;
        
              // create a new list of all users role(s)
              let userRoles = a['__acl_user_roles'] ? a['__acl_user_roles'] : {};
        
          
              // go through every user, and set up a default is one is missing
              this.users.forEach ( u => {
        
                // init
                if ( ! userRoles[u.id] ) {
                  userRoles[u.id] = supportMulti ? [] : '';
                }
        
                // no entries; needs default
                if (
                  ( supportMulti && userRoles[u.id].length == 0 )
                    ||
                  ( !supportMulti && userRoles[u.id] == '' )
                  ) {
                  if ( this.isUserOnAdminGroup ( u ) ) {
                    if ( defaults.get('admin') ) {
                      if ( supportMulti ) {
                        userRoles[u.id].push(defaults.get('admin'));
                      } else {
                        userRoles[u.id] = defaults.get('admin');
                      }
                    }
                  } else {
                    if ( defaults.get('user') ) {
                      if ( supportMulti ) {
                        userRoles[u.id].push(defaults.get('user'));
                      } else {
                        userRoles[u.id] = defaults.get('user');
                      }
                    }
                  }
                }
              });
              
              // make sure it's a nice clean object (no leaks!)
              for (var propName in this.userRoles) {
                if (this.userRoles[propName] === null || this.userRoles[propName] === undefined) {
                  delete this.userRoles[propName];
                }
              }
        
              // set it to the model
              this.userRoles = userRoles;
        
              // save a copy back to the Account
              a['__acl_user_roles'] = this.cleanObject ( this.userRoles );
              a.saveObservable().subscribe();
        
              // get all projects for all these users
              this.getProjects();
        
              // first time force role changes
              this.onRoleChange() ;
              this.onRolesChange() ;
        
              });
          */
            // hide the 'hang on, working' message
            Constants_1.Constants.hideHangOn();
        });
    }
    refreshInvited() {
        return this.fourD.activeTeam.invitedUsers.queryObservable().pipe(operators_1.tap(s => this.userList.next(this.userList.value.concat(s.items.map(ii => { return { user: ii, group: null, isAdmin: false, isInvite: true }; })))));
    }
    deleteInviteUser(u) {
        this.fourD.activeTeam.invitedUsers.removeObservable(u).subscribe(s => { this.refreshInvited(); });
    }
    cleanObject(obj) {
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj;
    }
    saveUserRules(user_id) {
    }
    onRolesChange() {
        this.fourD.activeTeam['__acl_user_roles'] = this.userRoles;
        this.fourD.activeTeam.saveObservable().subscribe();
    }
    onRoleChange() {
        // what am I allowed to do?
        console.log('users.comp');
        this.allowed = this.permissions.getAccess(this.permissions.roleSelected, true); // force refresh of role access
        this.viewRoleAllowed = this.allowed;
        // clone resources for presentation of access rules
        this.resources = this.permissions.deepClone(this.permissions.access_inv);
        this.viewRoleResources = this.resources;
    }
    viewRoleAccess(event) {
        const roleId = event.value;
        let role = this.roles.find(f => f.id == roleId);
        // what am I allowed to do?
        console.log('users.comp', event, roleId, role);
        // here; fetch ACL rules for this role
        // this.viewRoleAllowed = this.permissions.getAccess ( role, true ); // force refresh of role access
        // clone resources for presentation of access rules
        // this.viewRoleResources = this.permissions.deepClone ( this.permissions.access_inv );
        console.log('changeViewRole', role, this.viewRoleAllowed, this.viewRoleResources);
    }
    /*
      private getProjects() {
        this.fourD.V.searchByObject(Project).limit(1000).queryObservable().subscribe(value => {
          this.projects = value.items;
          this.projects.forEach(p => {
            p.shareUsers.queryObservable().subscribe(shareUsers => {
              shareUsers.items.forEach(user => {
                if (this.users.find(value1 => value1.id === user.id)) {
                  if (!this.users.find(value1 => value1.id === user.id)['projects']) {
                    this.users.find(value1 => value1.id === user.id)['projects'] = [];
                  }
                  this.users.find(value1 => value1.id === user.id)['projects'].push(p);
                }
              })
            });
          })
        });
      }
    */
    refreshUserGroups() {
        //this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.zzz.id)
        return this.fourD.activeTeam.accountGroups.queryObservable().pipe(operators_1.map(res => this.groups = res.items), operators_1.mergeMap(res => {
            let usersQueryObs = [];
            // Go through all AccessGroups and get the users obeservable and attach them to a forkJoin
            for (var i = 0; i < this.groups.length; i++) {
                let group = this.groups[i];
                usersQueryObs.push(group.users.queryObservable().pipe(operators_1.map(i => i.items.map(u => { return { user: u, group: group, isAdmin: group.uid.endsWith('_admins'), isInvite: false }; }))));
            }
            return rxjs_1.forkJoin(usersQueryObs).pipe(operators_1.map(a => {
                var res = [];
                a.forEach(aa => aa.forEach(aaa => res.push(aaa)));
                return res;
            }));
        }), operators_1.map(result => {
            this.userList.next(result.sort((a, b) => a.user.name.localeCompare(b.user.name)));
            this.loading = false;
        }));
    }
    userIndex(list, user) {
        var index = -1;
        for (var i = 0; i < list.length; i++) {
            let u = list[i];
            if (u.id == user.id)
                index = i;
        }
        return index;
    }
    changeUserAccess(event, user, group) {
        // If check is true it means we are adding the user to the group
        if (event.checked) {
            group.users.addObserveable(user).pipe(operators_1.mergeMap(e => {
                return this.refreshUserGroups();
            }))
                .subscribe(succ => {
                this.openSnackBarSuccess('USER_ADMIN.ADDED');
            }, err => {
                this.openSnackBarError('ERROR.VASAT', '', err);
            });
        }
        else {
            let remove = () => {
                group.users.removeObservable(user).pipe(operators_1.mergeMap(e => {
                    return this.refreshUserGroups();
                }))
                    .subscribe(succ => {
                    this.openSnackBarSuccess('USER_ADMIN.REMOVED');
                }, err => {
                    this.openSnackBarError('ERROR.VASAT', '', err);
                });
            };
            // If we are removing user from a group check it belongs to other groups, otherwise present a notification
            if (this.getUserGroups(user) > 1) {
                remove();
            }
            else {
                rxjs_1.forkJoin([
                    this.t.get('GENERIC.YES'),
                    this.t.get('GENERIC.NO')
                ]).subscribe(([yes, no]) => 
                // Show notification
                this.snotifyService.confirm('Would you like to remove user from all groups?', {
                    showProgressBar: false,
                    closeOnClick: false,
                    buttons: [
                        {
                            text: yes, action: (toast) => {
                                remove();
                            }, bold: true
                        },
                        {
                            text: no, action: (toast) => {
                                this.snotifyService.remove(toast.id);
                            }, bold: true
                        }
                    ]
                }));
            }
        }
    }
    changeAccessValidation(checkbox, user, group) {
        if (checkbox.checked) {
            // Don't allow to remove all admin users
            if (this.isAdminGroup(group) && !(group['cachedUsers'].length > 1)) {
                this.openSnackBarWarn('USER_ADMIN.NEED_ADMIN');
                return false;
            }
            // If checkbox value is checked it means we are about to remove the user from the group so lets check user belongs to more groups
            else if (!(this.getUserGroups(user) > 1)) {
                this.openSnackBarWarn('USER_ADMIN.NO_GROUPS');
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }
    inviteUser() {
        let dialogRef = this.dialog.open(user_add_dialog_1.AddUserDialog, {
            //width: '350px',
            data: { groups: this.groups }
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res) {
                this.fourD.V.api('/app/Account/' + this.fourD.activeTeam.id + '/invite/-1', 'post', res.user)
                    .subscribe(res1 => {
                    this.curUser = {
                        user: new vasat_1.User(this.service.V, res1.id).set(res1),
                        isAdmin: false,
                        isInvite: false,
                        group: this.groups.find(a => !a.uid.endsWith('_admins'))
                    };
                    this.openSnackBarSuccess('SETTINGS.INVITE_SENT');
                    // res1.group.users.queryObservable().subscribe();
                    this.refreshUserGroups().pipe(operators_1.flatMap(_ => this.refreshInvited())).subscribe();
                }, err => {
                    if (err.status == 92002)
                        this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_USER');
                    else
                        this.openSnackBarError('ERROR.VASAT', '', err);
                });
            }
        });
    }
    shareProject(user) {
        let dialogRef = this.dialog.open(share_project_dialog_component_1.ShareProjectDialog, {
            //width: '350px',
            data: {
                user: user,
                projects: this.projects
            }
        });
        dialogRef.afterClosed().subscribe(res => {
        });
    }
    /**
     * Cheks if the passed user belongs to the passed AccessGroup
     * @param user The user
     * @param group The AccessGroup
     */
    isUserOnGroup(user, group) {
        return group['cachedUsers'] ? group['cachedUsers'].find(u => u.id == user.id) : false;
    }
    getUserGroups(user) {
        var res = 0;
        for (var i = 0; i < this.groups.length; i++) {
            if (this.isUserOnGroup(user, this.groups[i]))
                res++;
        }
        return res;
    }
    /**
     * Check if the user is in admin group
     * @param user
     */
    isUserOnAdminGroup(user) {
        let adminGroup = this.groups.find(g => this.isAdminGroup(g));
        if (adminGroup) {
            return this.isUserOnGroup(user, adminGroup);
        }
        else {
            return false;
        }
    }
    /**
     * Check if the group is the Admin group
     * @param group
     */
    isAdminGroup(group) {
        if (group && group.uid) {
            return group.uid.indexOf('_admins') != -1;
        }
        else {
            return false;
        }
    }
    addTeam() {
        var inp = {};
        this.openDialog('SETTINGS.TEAM_NAME', '', 'GENERIC.OK', 'GENERIC.CANCEL', inp).subscribe(s => {
            if (s)
                new _4d_mapper_1.Account(this.fourD.V).set({ name: s, uid: s, parent: this.fourD.activeTeam }).saveObservable().subscribe(s => {
                    this.fourD.teams.push(s);
                    this.openSnackBarInfo('GENERIC.ADDED');
                }, e => this.openSnackBarError('GENERIC.ADDED_ERROR', e.message));
        });
    }
    deleteUser(user) {
        if (this.service.myProfile.id == user.id) {
            this.openSnackBarError('USER_ADMIN.DELETE_ERROR');
            return;
        }
        this.openConfirmDelete(() => {
            this.loading = true;
            rxjs_1.forkJoin(this.projects.map(project => {
                if (user['projects'] && user['projects'].indexOf(project) !== -1) {
                    return project.shareUsers.removeObservable(user);
                }
                else {
                    return rxjs_1.of('');
                }
            })).subscribe(_ => {
                let a = this.fourD.activeTeam;
                delete a['__acl_user_roles']['' + user.id];
                a.saveObservable().subscribe();
                rxjs_1.forkJoin(this.groups.map(group => group.users.removeObservable(user))).subscribe(_ => {
                    this.refreshUserGroups().subscribe();
                    this.openSnackBarSuccess('USER_ADMIN.USER_DELETED');
                });
            });
        }, user.name);
    }
}
exports.UsersComponent = UsersComponent;
